
window.exibirModal = function(idModal){
	const modal = window.bootstrap.Modal.getOrCreateInstance(`#${idModal}`);
	modal.show();
}

window.esconderModal = function(idModal){
	const modal = window.bootstrap.Modal.getOrCreateInstance(`#${idModal}`);
	modal.hide();
}

window.addEventListener('exibirModal', function(event){
	window.exibirModal(event.detail.idModal);
});

window.addEventListener('esconderModal', function(event){
	window.esconderModal(event.detail.idModal);
});
